import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import { Container, Select, Label, IconLeftContainer, IconRightContainer } from './styles';

const DEFAULT_PROPS = {
  marginButton: 0,
};

const Props = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  marginButton: PropTypes.number,
};

export default function IconSelect({
  onChange,
  value,
  icon,
  name,
  id,
  label,
  children,
  marginBottom,
}) {
  return (
    <Container marginBottom={marginBottom}>
      <Label htmlFor={id}>{label}</Label>
      <IconLeftContainer>
        <Icon name={icon} />
      </IconLeftContainer>
      <Select id={id} name={name} value={value} onChange={onChange}>
        {children}
      </Select>
      <IconRightContainer>
        <Icon name="expand_more" />
      </IconRightContainer>
    </Container>
  );
}

IconSelect.propTypes = Props;
IconSelect.defaultProps = DEFAULT_PROPS;
